export default __webpack_public_path__ + "img/fjCEPCfC.a1424fe0.svg";